import React, { useEffect, useMemo, useState } from 'react';
import { Button, Card, Typography } from 'antd';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { register } from '../../serviceWorker';

const { Title } = Typography;

const UpdateAlert = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [waitingServiceWorker, setWaitingServiceWorker] = useState(null);
  const [isUpdateAvailable, setUpdateAvailable] = useState(false);
  const [timer, setTimer] = useState(5);

  const value = useMemo(
    () => ({
      isUpdateAvailable,
      updateCache: () => {
        if (waitingServiceWorker) {
          waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
        }
      }
    }),
    [isUpdateAvailable, waitingServiceWorker]
  );

  useEffect(() => {
    register({
      onUpdate: (registration) => {
        setWaitingServiceWorker(registration.waiting);
        setUpdateAvailable(true);
      },
      onWaiting: (waiting) => {
        setWaitingServiceWorker(waiting);
        setUpdateAvailable(true);
      }
    });
  }, []);

  useEffect(() => {
    if (navigator?.serviceWorker) {
      navigator.serviceWorker.getRegistrations().then((regs) =>
        regs.forEach((reg) => {
          if (reg.waiting) {
            setWaitingServiceWorker(reg.waiting);
            setUpdateAvailable(true);
          }
        })
      );
    }
  }, [location]);

  useEffect(() => {
    // reload after getting update
    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener('statechange', (event) => {
        if (event.target.state === 'activated') {
          window.location.reload();
        }
      });
    }
  }, [waitingServiceWorker]);

  useEffect(() => {
    if (timer > 0 && isUpdateAvailable) {
      const timeOut = setTimeout(() => {
        setTimer(timer - 1);
      }, 1000);
      return () => clearTimeout(timeOut);
    }
    if (timer === 0 && isUpdateAvailable) {
      value.updateCache();
    }
    return undefined;
  }, [timer, isUpdateAvailable]);

  return (
    isUpdateAvailable &&
    timer > 0 && (
      <Card
        style={{
          position: 'fixed',
          zIndex: 1000,
          bottom: 10,
          right: 10,
          background: '#ffffff'
        }}
      >
        <Title level={4}>{t('update_alert.title')}</Title>
        <Button
          type="primary"
          onClick={value.updateCache}
          style={{ width: '100%' }}
        >
          {t('update_alert.button.content')}
          &nbsp;
          {timer}
          &nbsp;
          {timer > 1
            ? t('update_alert.button.time_indicator_plural')
            : t('update_alert.button.time_indicator_singular')}
        </Button>
      </Card>
    )
  );
};

export default UpdateAlert;
